// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"1583c880","404":"f38e74c9","498":"74eefb8b","919":"cc483259"}[chunkId] + ".chunk.js";
};